export default function genererParametreTable(nbreResultParPage) {
  return {
    nbResultatParPage: nbreResultParPage,
  };
}
